<template>
<section class="loginPage">
  <toaster />
  <spinner color="#FFF"/>
  <!-- <login-resp v-if="user == 'responsavel'" :section="section" @recuperasenha="toggleRecuperaSenha"></login-resp> -->
  <login-user></login-user>
</section>
  
</template>

<script>

import LoginUser from '@/components/auth/LoginUser'
// import LoginResp from '@/components/auth/LoginResp'

export default {
  name: 'Login',
  components: {
    LoginUser,
    // LoginResp
  },
  props: {
    user: {
      type: String
    },
    section: {
      type: String
    }
  },
  data() {
    return {
      recuperaSenha: false
    };
  },
  computed: {
    
  },
  mounted () {
    if ( this.section ) {
      this.$router.push({name: 'Login', params: { section: ''} })
    }
  },
  methods: {
    toggleRecuperaSenha () {
      this.recuperaSenha = !this.recuperaSenha
      const section = this.recuperaSenha ? 'recupera-senha' : ''

      this.$router.push({name: 'Login', params: { user: this.user, section: section} })
    }
  }
}

</script>

<style lang="scss" scoped>

.loginPage {
  width: 100vw; min-height: 100vh;
  overflow: hidden;
  display: flex; align-content: center; align-items: center;
  justify-content: center; flex-direction: column;
  background-image: linear-gradient(to right bottom, #ec5258, #ed4a4f, #ee4146, #ee383c, #ee2d32, #e6272d, #de2128, #d61b23, #c51b22, #b51a21, #a41a20, #94191e);
}

</style>